<nz-modal [(nzVisible)]="visible" nzTitle="Currency Details" (nzOnCancel)="handleCancel()" (nzOnOk)="handleOk()"
  [nzOkDisabled]="!hasPermission">
  <ng-container *nzModalContent>
    <form nz-form se-container="2" labelWidth="180" nzLayout="vertical" [formGroup]="form">
      <se>
        <nz-row nzGutter="16">
          <nz-col nzSpan="12">
            <se label="Currency" error="Currency code is required.">
              <nz-select formControlName="code" app-auto-focus nzPlacement="bottomLeft" nzShowSearch class="width-100"
                [required]="true" [nzDropdownMatchSelectWidth]="false" (nzOnSearch)="search($event)"
                [nzFilterOption]="nzFilterOption">
                <nz-option *ngFor="let item of options" [nzLabel]="item.code" [nzValue]="item.code" nzCustomContent>
                  <div class="dropdown-container">
                    <strong>{{ item.code }}</strong> - <span> {{ item.name }}</span>
                  </div>
                </nz-option>
              </nz-select>
            </se>
          </nz-col>
          <nz-col nzSpan="12">
            <se label="Sign" error="Currency sign is required.">
              <input nz-input formControlName="sign" maxlength="5" required />
            </se>
          </nz-col>
        </nz-row>
      </se>

      <se>
        <nz-row nzGutter="16">
          <nz-col nzSpan="12">
            <se label="Name" error="Currency name is required.">
              <input nz-input formControlName="name" maxlength="100" required />
            </se>
          </nz-col>
          <nz-col nzSpan="12">
            <se label="Cent Format">
              <input nz-input formControlName="centFormat" maxlength="20" />
            </se>
          </nz-col>
        </nz-row>
      </se>

      <ng-container *ngIf="!this.form.controls.local.value">
        <se>
          <nz-row nzGutter="16">
            <nz-col nzSpan="12">
              <se label="Default Sales Rate">
                <input nz-input formControlName="defaultSalesRate" app-number-input [precision]="8"
                  [defaultValue]="1" />
              </se>
            </nz-col>
            <nz-col nzSpan="12">
              <se label="Default Purchase Rate">
                <input nz-input formControlName="defaultPurchaseRate" app-number-input [precision]="8"
                  [defaultValue]="1" />
              </se>
            </nz-col>
          </nz-row>
        </se>

        <se>
          <nz-row nzGutter="16">
            <nz-col nzSpan="24">
              <se label="Forex Gain Account" error="Forex Gain Account is required">
                <app-gl-acc-select [allowClear]="true" formControlName="forexGainAccount" valueField="" required>
                </app-gl-acc-select>
              </se>
            </nz-col>
            <nz-col nzSpan="24">
              <se label="Forex Loss Account" error="Forex Loss Account is required">
                <app-gl-acc-select [allowClear]="true" formControlName="forexLossAccount" valueField="" required>
                </app-gl-acc-select>
              </se>
            </nz-col>
          </nz-row>
        </se>
      </ng-container>
    </form>
  </ng-container>
</nz-modal>